import { DatasourceServerLinkIcon } from '@tableau/icons/DatasourceServerLinkIcon';
import { call } from 'redux-saga/effects';

import { ServerFilterClauses } from '~commonInfra/utils/ServerFilterClauses';
import { Messages } from '~src/codegen/Localize';
import { PublishedConnectionCard } from '~src/publishedConnection/components/cardView/PublishedConnectionCard';
import { PublishedConnections } from '~src/publishedConnection/resources/PublishedConnections';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { ContentTypeFilterClause,MixedContentItemDefinition, SpaceDefinition } from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { PublishedConnectionContentType } from '~src/spacesPlatform/models/ContentTypes';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { getPublishedConnectionInfos } from '~src/spacesPlatform/sagas/SpacesSagaHelpers';

import { getGenericDefaultFilters } from '../../spacesPlatform/contentDefinitions/getDefaultFilters';

export const PublishedConnectionDefinition: MixedContentItemDefinition & SpaceDefinition<'virtualConnection'> = {
  itemType: 'virtualConnection',
  contentType: 'virtualConnection',
  singularName: Messages.publishedConnection,
  pluralName: Messages.publishedConnections,
  emptyStateMessage: Messages.publishedConnectionsEmptyMessage,
  siteFilterByTypeDropdownName: Messages.siteFilterByTypeDropdown_PublishedConnections,
  contentFilterKeys: PublishedConnectionContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: PublishedConnectionCard,
  listViewIconType: DatasourceServerLinkIcon,
  filterClause: ServerFilterClauses.ContentType(['virtualConnection']) as ContentTypeFilterClause,
  contentSpaceUrl: (urls: SpacesSiteUrls, contentId: string) => urls.virtualConnectionUrl(contentId),
  getBasicQuery: () => {
    return PublishedConnections.all().withExtraParams(PublishedConnectionContentType.extraQueryParams);
  },
  fieldValueResourceType: 'virtualConnection',
  getContentInfo: (contentList: IContentInfo[]) => call(getPublishedConnectionInfos, contentList),
  supportedDisplayModes: ['list', 'thumbnail'],
  headerIconPath: (contentInfo) => PublishedConnections.getPublishedConnectionHeaderIconPath(contentInfo),
};
